import React from 'react';
import { Icon } from './Icon.js';
export const IconVShapedArrowUpFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "M11.1954 6.64645C11.5286 6.89224 11.5993 7.36195 11.3536 7.69528C11.1078 8.0284 10.6381 8.0991 10.3048 7.85348L6.00012 4.68161L1.69544 7.85348C1.3621 8.0991 0.8924 8.0284 0.646608 7.69528C0.400996 7.36195 0.471689 6.89224 0.804811 6.64645L5.55481 3.14645C5.81938 2.95151 6.18087 2.95151 6.44544 3.14645L11.1954 6.64645Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconVShapedArrowUpFill12.js.map